
const defaultOptions = {
    /**
     *  require   主域名地址 - matomo 配置监听的域名 http://matomo.tb.com
     */
    host: "http://tongji.tbatb.net",
    /**
     *  require    maomo 配置是siteId
     */
    siteId: "1",

    /**
     *  require   加载.js .php 文件名称
     *  默认 matomo
     */
    trackerFileName: 'matomo',

    /**
     *  options  监听域名的全路径, e.g http://matomo.tb.com.matomo.js
     *  默认 undefined
     */
    trackerScriptUrl: undefined,

    /**
     *  options  tracker全路径, e.g http://matomo.tb.com.matomo.php
     *  默认 undefined
     */
    trackerUrl: undefined,

    /**
     * options  是否允许link 追踪,
     *  默认 true
     */
    enableLinkTracking: true,

    /**
     * options  是否使能心跳连接,
     *  默认 true
     */
    enableHeartBeatTimer: true,

    /**
     * options  心跳连接时间间隔, 网页的访问时间
     *  默认 15s
     */
    heartBeatTimerInterval: 15,

    /**
     * options  是否支持用户id 事件
     * 默认  true
     */
    supportUserId: true,

    /**
     * options  多域名  e,g  ["*.hostname1.com", "hostname2.com"]
     * 默认  undefined
     */
    domains: undefined,

    /**
     * 是否是Debug 模式
     * 默认  false
     */
    debug: false,

    /**
     * 是否开启监听
     *  默认开启
     */
    open: true,
};

export default  defaultOptions;